import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { ANONYM_USER, IS_BIZ_USER, IS_MOBILE_BROWSER, IS_PAID_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type TariffIds = {
    month: string;
    year: string;
};

const segment = !IS_BIZ_USER && !IS_PAID_USER && !ANONYM_USER && (IS_WEBVIEW || IS_MOBILE_BROWSER);

const upsaleSmallModalValue = getFeature('upsale-small-modal');

const upsaleSmallModal: 'a' | 'b' | 'c' = upsaleSmallModalValue || 'a';

export const enabledUpsaleSmallModalB: boolean = upsaleSmallModal === 'b';

export const enabledUpsaleSmallModalC: boolean = upsaleSmallModal === 'c';

export const enabledUpsaleSmallModal: boolean = segment && (enabledUpsaleSmallModalB || enabledUpsaleSmallModalC);

export const tariffUpsale: TariffIds = getFeature('upsale-small-tariff-ids') || {
    month: 'W256GB_1m_baz_upsell_force_trial_14d',
    year: 'W256GB_1y_baz_upsell_discount_force_trial_14d',
};

if (segment) {
    registerExperiment(
        'upsale-to-baz',
        upsaleSmallModalValue,
        [
            AnalyticEventNames.UPSALE_BAZ_MODAL_SHOW,
            AnalyticEventNames.UPSALE_BAZ_MODAL_CLICK,
            AnalyticEventNames.UPSALE_BAZ_MODAL_REJECT,
            AnalyticEventNames.UPSALE_BAZ_MODAL_SWITCH,
            AnalyticEventNames.UPSALE_BAZ_MODAL_CONTINUE,
            AnalyticEventNames.UPSALE_BAZ_MODAL_CLOSE,
        ],
        {
            mapEventNames: {
                UPSALE_BAZ_MODAL_SHOW: 'show',
                UPSALE_BAZ_MODAL_CLICK: 'click',
                UPSALE_BAZ_MODAL_REJECT: 'reject',
                UPSALE_BAZ_MODAL_SWITCH: 'switch',
                UPSALE_BAZ_MODAL_CONTINUE: 'continue',
                UPSALE_BAZ_MODAL_CLOSE: 'close',
            },
        }
    );
}
